var render, staticRenderFns
import script from "./details_of_counterfeit_goods.vue?vue&type=script&lang=js"
export * from "./details_of_counterfeit_goods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('907d1202')) {
      api.createRecord('907d1202', component.options)
    } else {
      api.reload('907d1202', component.options)
    }
    
  }
}
component.options.__file = "found/views/cps/views/execute/details_of_counterfeit_goods/details_of_counterfeit_goods.vue"
export default component.exports